import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={78}
    height={78}
    viewBox={'0 0 78 78'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#B15500'}
      fillRule="evenodd"
      d="M39 68.64c18.954 0 34.32-15.366 34.32-34.32S57.954 0 39 0 4.68 15.366 4.68 34.32c0 10.673 4.872 20.207 12.512 26.502.012.01.002.03-.013.024a.014.014 0 0 0-.019.014v10.644c0 2.98 3.14 4.913 5.8 3.572l12.012-6.055a4.256 4.256 0 0 1 2.148-.432c.623.034 1.25.051 1.88.051Z"
      clipRule="evenodd"
    />
    <Path
      fill={props.stroke || '#fff'}
      fillRule="evenodd"
      d="M35.87 36.565a3 3 0 0 0 3 3h.26a3 3 0 0 0 3-3V23.087a3 3 0 0 0-3-3h-.26a3 3 0 0 0-3 3v13.478ZM39 47.913a3.13 3.13 0 1 0 0-6.26 3.13 3.13 0 0 0 0 6.26Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default SvgComponent;
